module.exports = __webpack_public_path__ + "static/media/14.602c762f.png";